/**
 * ─────────────────────────────────────────────
 * src/hooks/useDashboard.js
 * ─────────────────────────────────────────────
 *
 * Exposes all dashboard state and actions to components.
 * Components import this — never import from the slice directly.
 */

import { useDispatch, useSelector } from "react-redux";
import {
  fetchDashboard,
  fetchDashboardProjects,
  fetchDisabledProjects,
  fetchDashboardGraphs,
  addProjectToList,
  clearDashboardErrors,
} from "../store/slices/dashboardSlice";

const useDashboard = () => {
  const dispatch = useDispatch();

  const {
    stats,
    projectOverview,
    projects,
    disabledProjects,
    upcomingMilestones,
    weeklyProgress,
    overallCompletion,
    resourceAllocation,
    isDashboardLoading,
    isProjectsLoading,
    isDisabledProjectsLoading,
    isGraphsLoading,
    dashboardError,
    projectsError,
    disabledProjectsError,
    graphsError,
  } = useSelector((state) => state.dashboard);

  return {
    // ── State ──────────────────────────────
    stats,
    projectOverview,
    projects,
    disabledProjects,
    upcomingMilestones,
    weeklyProgress,
    overallCompletion,
    resourceAllocation,

    // ── Loading ────────────────────────────
    isDashboardLoading,
    isProjectsLoading,
    isDisabledProjectsLoading,
    isGraphsLoading,

    // ── Errors ─────────────────────────────
    dashboardError,
    projectsError,
    disabledProjectsError,
    graphsError,

    // ── Actions ────────────────────────────
    loadDashboard: (sortBy) => dispatch(fetchDashboard(sortBy)),
    loadProjects: (sortBy) => dispatch(fetchDashboardProjects(sortBy)),
    loadDisabledProjects: (sortBy) => dispatch(fetchDisabledProjects(sortBy)),
    loadGraphs: (projectId) => dispatch(fetchDashboardGraphs(projectId)),
    addProject: (project) => dispatch(addProjectToList(project)),
    clearErrors: () => dispatch(clearDashboardErrors()),
  };
};

export default useDashboard;
